module.exports = __webpack_public_path__ + "static/media/card-main3.0b672bf8.png";